import React, { useState } from 'react';
import Particle from '../Particle';

const ContactUs = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted!');
    console.log('Name:', name);
    console.log('Email:', email);
    console.log('Phone Number:', phoneNumber);
    console.log('Message:', message);
    // Reset form fields
    setName('');
    setEmail('');
    setPhoneNumber('');
    setMessage('');
  };

  return (
    <section>
      <Particle />

      <div className="contactus-content">
        <div className="contact_us_8">
          <div className="responsive-container-block container">
            <form className="form-box" onSubmit={handleSubmit}>
              <div className="container-block form-wrapper">
                <div className="responsive-container-block">
                  <div className="responsive-cell-block wk-tab-12 wk-mobile-12 wk-desk-8 wk-ipadp-12" id="i10mt-9">
                    <input
                      className="input"
                      id="ijowk-9"
                      name="FirstName"
                      placeholder="Enter your Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>

                  <div className="responsive-cell-block wk-tab-12 wk-mobile-12 wk-desk-8 wk-ipadp-12" id="iajvf">
                    <input
                      className="input"
                      id="ipmgh-9"
                      name="Email"
                      placeholder="Enter your Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="responsive-cell-block wk-tab-12 wk-mobile-12 wk-desk-8 wk-ipadp-12" id="i0txn">
                    <input
                      className="input"
                      id="imgis-8"
                      name="PhoneNumber"
                      placeholder="Enter your Phone Number"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                    />
                  </div>

                  <div className="responsive-cell-block wk-tab-12 wk-mobile-12 wk-desk-8 wk-ipadp-12" id="i634i-9">
                    <textarea
                      className="textinput"
                      id="i5vyy-9"
                      placeholder="What’s on your mind?"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    ></textarea>
                  </div>

                  <div className="responsive-cell-block wk-tab-12 wk-mobile-12 wk-desk-8 wk-ipadp-12" id="i0txn-2">
                    <button type="submit" className="submit-btn">
                      Submit
                    </button>
                  </div>
                </div>

                <div className="right-side-text">
                  <p className="text-blk contactus-head">Get in Touch</p>
                  <p className="text-blk contactus-subhead">
                    Please fill out the form below to get in touch with us.
                  </p>
                  <div className="social-media-links">
                    <a href="#" id="ix94i-2-3">
                      <img className="link-img" src="https://workik-widget-assets.s3.amazonaws.com/Footer1-83/v1/images/Icon-twitter.png" />
                    </a>
                    <a href="#">
                      <img className="link-img" src="https://workik-widget-assets.s3.amazonaws.com/Footer1-83/v1/images/Icon-facebook.png" />
                    </a>
                    <a href="#">
                      <img className="link-img" src="https://workik-widget-assets.s3.amazonaws.com/Footer1-83/v1/images/Icon-google.png" />
                    </a>
                    <a href="#" id="izldf-2-3">
                      <img className="link-img" src="https://workik-widget-assets.s3.amazonaws.com/Footer1-83/v1/images/Icon-instagram.png" />
                    </a>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
